var path = '/templates/zenclerk_s/sites/dashboard/set-tag-button.html';
var html = "<div class=\"btn btn-primary btn-shadow set-tag-button\" ng-click=$ctrl.goToTagSetupPage()><ng-transclude>{{ 'sites.dashboard.setTagButton.tagu_settei' | translate }}</ng-transclude></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/zenclerk_s_modules/zenclerk_s/sites/dashboard/set-tag-button.html
// module id = 1407
// module chunks = 0